<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Lesson</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Lesson</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'LessonList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Course</strong>
                      <span v-if="!_.isNil(value.course_id)">{{ pre.course_id[value.course_id] }}</span>
                    </li>

                  <li><strong>Section</strong>
                      <span v-if="!_.isNil(value.section_id)">{{ pre.section_id[value.section_id] }}</span>
                    </li>

                  <li><strong>Lesson Title</strong> {{ value.lesson_title }}</li>

                  <li><strong>Lesson Tyoe</strong> {{ value.lesson_type }}</li>

                  <li><strong>Quiz</strong> {{ value.quiz_id }}</li>

                  <li><strong>File</strong>
                      <a @click="downloadFile(value.file_path)" href="javascript:void(0)" class="btn btn-info">Download</a>
                      </li>

                  <li><strong>File 480</strong>
                      <a @click="downloadFile(value.file_path_480)" href="javascript:void(0)" class="btn btn-info">Download</a>
                      </li>

                  <li><strong>File 720</strong>
                      <a @click="downloadFile(value.file_path_720)" href="javascript:void(0)" class="btn btn-info">Download</a>
                      </li>

                  <li><strong>File 1080</strong>
                      <a @click="downloadFile(value.file_path_1080)" href="javascript:void(0)" class="btn btn-info">Download</a>
                      </li>

                  <li><strong>Other File</strong>
                      <a @click="downloadFile(value.other_file)" href="javascript:void(0)" class="btn btn-info">Download</a>
                      </li>

                  <li><strong>Duration</strong> {{ value.duration }}</li>

                  <li><strong>Display Order</strong> {{ value.display_order }}</li>

                  <li><strong>Description</strong> {{ value.description }}</li>

                  <li><strong>Form Course</strong> {{ value.form_course }}</li>

                  <li><strong>Conversion Status</strong> {{ value.conversion_status }}</li>

                  <li><strong>Featured Image</strong>
                      <a @click="downloadFile(value.featured_image)" href="javascript:void(0)" class="btn btn-info">Download</a>
                      </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Vocabularies</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                <tr>

                  <th>ID</th>
                  <th>Translate from</th>
                  <th>Translate to</th>
                  <th>Display Order</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(val, index) in value.vocabularies">

                  <td>{{ val.id }}</td>
                  <td>{{ val.translate_from }}</td>
                  <td>{{ val.translate_to }}</td>
                  <td>{{ val.display_order }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Faqs</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                <tr>

                  <th>ID</th>
                  <th>Question</th>
                  <th>Answer</th>
                  <th>Display Order</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(val, index) in value.faqs">

                  <td>{{ val.id }}</td>
                  <td>{{ val.question }}</td>
                  <td>{{ val.answer }}</td>
                  <td>{{ val.display_order }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>

    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download")
import { Notification } from "element-ui";


export default {
  name: "LessonShow",
  metaInfo: {
    title: "Lesson | Dotlines"
  },
  data: () => ({
    value: {
      vocabularies: [],faqs: [],
    },
    pre: {
      course_id: [],section_id: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    courseIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/8")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    sectionIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/9")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.courseIdOptions().then(course_id => {
        this.pre.course_id = course_id;
      });
      await this.sectionIdOptions().then(section_id => {
        this.pre.section_id = section_id;
      });


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function(url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({title: "Download Completed", message: "Download completed successfully", type: "success"});
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/lessons/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
